import { Pdfgqr } from '../../../models/pdfgqr.model';
import { PdfgenerateqrService } from '../../../services/pdfgenerateqr.service';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { Location, NgFor } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';

@Component({
  templateUrl: './pdf.component.html',
  styles: [
    `
      .cuadro {
        width: 265px;
        height: 265px;
        border: 2px solid black;
        padding: 5px;
        margin: 20px;
        overflow: hidden;
      }

      .spinner-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        color: white;
      }

      .spinner {
        border: 16px solid #f3f3f3;
        border-top: 16px solid #3498db;
        border-radius: 50%;
        width: 120px;
        height: 120px;
        animation: spin 2s linear infinite;
      }
      .pdf-container {
        position: relative;
      }

      .loading-spinner {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(
          255,
          255,
          255,
          0.5
        ); /* Color de fondo blanco con opacidad */
        z-index: 999; /* Asegura que el spinner esté por encima de todo */
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(10px); /* Aplica el efecto de difuminado */
      }

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `,
  ],
  standalone: true,
  imports: [NgFor, QRCodeModule],
})
export class PdfComponent implements OnInit, AfterViewInit {
  currentQR: any;
  public listQr: Pdfgqr[] = [];
  public loading: boolean = false; // Variable para controlar el spinner

  constructor(
    private datopdfService: PdfgenerateqrService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.loading = true;
    console.log('datos de pdf', this.datopdfService.dato);

    this.listQr = this.datopdfService.dato;

    console.log('List', this.listQr);
    window.onload = () => {
      this.downloadpdf('printpdf');
    };
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.downloadpdf('printpdf');
      this.location.back();
    }, 0);
  }

  async downloadpdf(captureid: string) {
    const pdf = new jspdf.jsPDF();

    // Cambio 2: Captura individual de elementos
    const elements = document.querySelectorAll(`#${captureid} .col-12`);
    const Distentrefilas = 95; //Distancia entre las filas
    const itemsPerPage = 6; // Imprimir seis imágenes por página
    const tamañoimg = 96; //configurar tamaño de la imagen hija
    const posa = 8; //margen columna A
    const posb = 105; //margen columna B

    // Cambio 3: Promesas para capturas de canvas
    const promises = Array.from(elements).map((element, index) =>
      html2canvas(element as HTMLElement, { scale: 2 }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        return { imgData, index };
      })
    );

    const images = await Promise.all(promises);

    const addPageWithImages = (
      imageDataArray: { imgData: string; index: number }[]
    ) => {
      for (let i = 0; i < imageDataArray.length; i += itemsPerPage) {
        if (i > 0) {
          pdf.addPage(); // Agregar una nueva página para las siguientes imágenes
        }
        if (i < imageDataArray.length) {
          pdf.addImage(
            imageDataArray[i].imgData,
            'PNG',
            posa,
            0,
            tamañoimg,
            tamañoimg
          );
        }
        if (i + 1 < imageDataArray.length) {
          pdf.addImage(
            imageDataArray[i + 1].imgData,
            'PNG',
            posb,
            0,
            tamañoimg,
            tamañoimg
          );
        }
        if (i + 2 < imageDataArray.length) {
          pdf.addImage(
            imageDataArray[i + 2].imgData,
            'PNG',
            posa,
            Distentrefilas,
            tamañoimg,
            tamañoimg
          );
        }
        if (i + 3 < imageDataArray.length) {
          pdf.addImage(
            imageDataArray[i + 3].imgData,
            'PNG',
            posb,
            Distentrefilas,
            tamañoimg,
            tamañoimg
          );
        }
        if (i + 4 < imageDataArray.length) {
          pdf.addImage(
            imageDataArray[i + 4].imgData,
            'PNG',
            posa,
            Distentrefilas * 2,
            tamañoimg,
            tamañoimg
          );
        }
        if (i + 5 < imageDataArray.length) {
          pdf.addImage(
            imageDataArray[i + 5].imgData,
            'PNG',
            posb,
            Distentrefilas * 2,
            tamañoimg,
            tamañoimg
          );
        }
      }
    };

    addPageWithImages(images);
    pdf.save('Puestos de trabajo.pdf');
    this.loading = false;
  }
}
